export const MuiOutlinedInput = {
    styleOverrides: {
        notchedOutline: ({ theme })=>({
                borderColor: theme.palette.border.prominent
            })
    }
};

//# sourceMappingURL=outlined-input.js.map